import { Box, styled } from "@mui/material"

export const WebcamContainer = styled(Box)({
  width: "100%",
  height: "100%",
  position: "relative",
  overflow: "hidden",
})
